import React, { useState, useMemo, useEffect } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export interface ProcessingStatusProps {
  toolboxItemsCount: number;
}

/** AI 处理状态组件 - 动态文案 */
export const ProcessingStatus: React.FC<ProcessingStatusProps> = ({
  toolboxItemsCount,
}) => {
  const { t } = useTranslation("assessments");
  const [statusIndex, setStatusIndex] = useState(0);

  const statusMessages = useMemo(() => {
    const messages = [
      { icon: "🔍", text: t("pipeline.processing.identifyingOutline") },
      { icon: "🔬", text: t("pipeline.processing.analyzingLesions") },
      { icon: "🧬", text: t("pipeline.processing.matchingSymptoms") },
    ];
    if (toolboxItemsCount > 0) {
      messages.push({
        icon: "🧰",
        text: t("pipeline.processing.generatingWithToolbox", {
          count: toolboxItemsCount,
        }),
      });
    }
    messages.push({
      icon: "📋",
      text: t("pipeline.processing.generatingReport"),
    });
    return messages;
  }, [toolboxItemsCount, t]);

  useEffect(() => {
    const interval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % statusMessages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [statusMessages.length]);

  const currentStatus = statusMessages[statusIndex];

  return (
    <motion.div
      className="flex items-center gap-3 px-4 py-3 rounded-lg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.span
        key={statusIndex}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="text-xl"
      >
        {currentStatus.icon}
      </motion.span>
      <motion.p
        key={`text-${statusIndex}`}
        initial={{ opacity: 0, x: 10 }}
        animate={{ opacity: 1, x: 0 }}
        className="text-sm text-white font-medium"
      >
        {currentStatus.text}
      </motion.p>
    </motion.div>
  );
};
